module.exports = "https://cdn.realtymogul.com/static/media/img_location_nb.fa7efea4.jpg";